<template>
    <div class="flex flex--column">
        <div class="width--100 flex flex--center main">
            <div class="main--mock">
                <img src="../../assets/img/Mockup.png" alt="Mockup of the main screen" class="height--90"/>
            </div>
            <div class="color--primary flex flex--column">
                <h1>
                  Doguniversity
                </h1>
                <h2 class="color--primaryDark mar--bottom__2">
                    Deine digitale Hundeschule
                </h2>
                <p class="color--primaryDark mar--bottom__2">
                    Die Doguniversity arbeitet nach neusten wissenschaftlichen <br /> Erkenntnissen und hat es sich zur Aufgabe gemacht professionelles <br /> Hundetraining an Hund und Halter zu vermitteln.
                </p>
                <div class="flex">
                    <a href="https://apps.apple.com/us/app/id1525348472" target="_blank">
                        <img src="../../assets/img/DownloadAppStoreDark.png" alt="Download Icon for iOS" class="height--3 mar--right__2 clickable"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=neon.dog_university_app&hl=de" target="_blank">
                        <img src="../../assets/img/DownloadPlayStoreDark.png" alt="Download Icon for Android" class="height--3 clickable"/>
                    </a>
                </div>
<!--                <div class="mar&#45;&#45;top__1 font&#45;&#45;s16 color&#45;&#45;greyDark font&#45;&#45;w500 lineHeight&#45;&#45;12 pad&#45;&#45;1 b-radius&#45;&#45;5 border&#45;&#45;medium flex flex&#45;&#45;column">-->
<!--                    <div class="mar&#45;&#45;bottom__1">-->
<!--                        Disclaimer: Die hier bereitgestellten Apps sind <br />-->
<!--                        Entwicklungsversionen weshalb es zu Fehlern kommen kann.<br />-->
<!--                        Zur Installation auf iOS Geräten wird zusätzlich <br />-->
<!--                        die App "TestFlight" benötigt.-->
<!--                    </div>-->
<!--                    <a class="noDec font&#45;&#45;w700 font&#45;&#45;s16 pad&#45;&#45;1 b-radius&#45;&#45;5 bgColor&#45;&#45;primary color&#45;&#45;white flex flex&#45;&#45;center" href="https://apps.apple.com/de/app/testflight/id899247664" target="_blank">-->
<!--                        Testflight herunterladen-->
<!--                    </a>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "MainLoader"
    }
</script>
